import { Select } from "antd";
import React from "react";

const { Option } = Select;

const SelectStatus = (props) => {
  return (
    <Select className="w-100" dropdownStyle={{ zIndex: 1080 }} {...props}>
      <Option value="">ทั้งหมด</Option>
      <Option value="request">รอดำเนินการ</Option>
      <Option value="approve">อนุมัติ</Option>
      <Option value="reject">ปฎิเสธ</Option>
    </Select>
  );
};

export default SelectStatus;
